import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M4 11.979a4.48 4.48 0 0 1 5.392-4.386 7.5 7.5 0 0 1 1.127-1.236 5.979 5.979 0 1 0 3.375 3.082c-.485.298-.877.73-1.126 1.244a4.5 4.5 0 0 1 0 2.591 4.49 4.49 0 0 1-3.376 3.09l-.01.003q-.439.09-.903.09A4.48 4.48 0 0 1 4 11.98" fill="#4C9C50"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.472 11.979c0-.908.202-1.769.565-2.54a6 6 0 0 1 3.374-3.082 5.979 5.979 0 1 1 0 11.244c.42-.369.798-.784 1.127-1.236q.442.092.913.093a4.479 4.479 0 1 0-4.289-3.184 3 3 0 0 1-1.125 1.245 6 6 0 0 1-.565-2.54" fill="#4C9C50"/>' }
  })
);